export const BREAKPOINTS = {
  mobile: 599,
  tablet: 899,
  desktop: 1199,
};
